// --------------- Constants ---------------
import {
    TABLE_TITLE_DASHBOARD, TABLE_TITLE_NEW_LEADS, TABLE_TITLE_CONSULTATION_BOOKED,
    TABLE_TITLE_CONSULTATION_ATTENDED, TABLE_TITLE_TREATMENT_STARTED, TABLE_TITLE_FAILED_TO_ATTEND,
    TABLE_TITLE_COMPLETED, TABLE_TITLE_ARCHIVED, TABLE_TITLE_NO_TASK, TABLE_TITLE_ALIGNER,
    TABLE_TITLE_ATTENDED_CHECKLISTS,
} from 'src/constants/tableTitles';

export const TABLE_NAMES = [
    TABLE_TITLE_DASHBOARD, TABLE_TITLE_NEW_LEADS, TABLE_TITLE_CONSULTATION_BOOKED, TABLE_TITLE_CONSULTATION_ATTENDED,
    TABLE_TITLE_TREATMENT_STARTED, TABLE_TITLE_FAILED_TO_ATTEND, TABLE_TITLE_COMPLETED, TABLE_TITLE_ARCHIVED,
    TABLE_TITLE_NO_TASK, TABLE_TITLE_ALIGNER,
    'invisalignAdditional', 'Completed', 'Vivera table',
];

export const TABLE_SHORT_NAMES = {
    'Dashboard': 'Dashboard',
    'Newest Leads': 'Newest',
    'Consultation Booked Leads': 'Booked',
    'Consultation Attended Leads': 'Attended',

    'Treatment Started Leads': 'Started',
    'Failed to attend Leads': 'FTA',
    'Completed Leads': 'Completed',
    'Archived Leads': 'Archived',
    'No Task Assigned': 'No Task',
    'Aligner Approve Leads': 'Aligner',
    'invisalignAdditional': 'Invisalign Extra',
    'Completed': 'Aligner Completed',
    'Vivera table': 'Vivera',
};

// Maps the Redux tableType string used by each parent-table page to the canonical
// tableTitle string used as the key in practice.preferences.default_filters.
// Single source of truth — eliminates per-callsite string literals in useDefaultTreatmentFilter.
export const TABLE_TYPE_TO_TITLE = {
    NewLeadTable:          TABLE_TITLE_NEW_LEADS,
    ConsultantBooked:      TABLE_TITLE_CONSULTATION_BOOKED,
    ConsultantAttend:      TABLE_TITLE_CONSULTATION_ATTENDED,
    AttendedChecklists:    TABLE_TITLE_ATTENDED_CHECKLISTS,
    treatmentStarted:      TABLE_TITLE_TREATMENT_STARTED,
    FailedToAttend:        TABLE_TITLE_FAILED_TO_ATTEND,
    Closed:                TABLE_TITLE_COMPLETED,
    ArchiveTable:          TABLE_TITLE_ARCHIVED,
    NoTaskTable:           TABLE_TITLE_NO_TASK,
    treatmentStartedWithInvisalign: TABLE_TITLE_ALIGNER,
    Dashboard:             TABLE_TITLE_DASHBOARD,
};

// TODO: Load dynamic practice choice columns from choicesData API and add to column list
// TODO: Add column width configuration (slider or input per column)

export const COLUMNS_PER_TABLE = {
    'Dashboard': ['created_at', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'referral', 'status', 'contact', 'lastContact', 'assignee', 'tag', 'viewDetails', 'actions'],
    'Newest Leads': ['created_at', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'viewDetails', 'actions'],
    'Consultation Booked Leads': ['lead_treatments__appointments__datetime', 'lead_name', 'first_name', 'last_name', 'assignee', 'created_at', 'email', 'deposit_pending', 'payment_method', 'app_method', 'app_type', 'booked_with', 'phone', 'treatment', 'referral', 'contact', 'lastContact', 'tag', 'viewDetails', 'actions'],
    'Consultation Attended Leads': ['date_attended', 'lead_name', 'first_name', 'last_name', 'assignee', 'created_at', 'email', 'deposit_pending', 'payment_method', 'clin_check_status', 'app_method', 'app_type', 'booked_with', 'phone', 'treatment', 'price', 'referral', 'contact', 'lastContact', 'lead_treatments__lead_contacted_counts__count', 'tag', 'viewDetails', 'actions'],

    'Treatment Started Leads': ['transition_date', 'lead_name', 'first_name', 'last_name', 'assignee', 'created_at', 'email', 'payment_method', 'consultation_date', 'consultation_booked_with', 'date_attended', 'booked_with', 'phone', 'treatment', 'price', 'referral', 'contact', 'lastContact', 'tag', 'viewDetails', 'actions'],
    'Failed to attend Leads': ['date_attended', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'viewDetails', 'actions'],
    'Completed Leads': ['created_at', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'price', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'viewDetails', 'actions'],
    'Archived Leads': ['archived_at', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'contact', 'status', 'assignee', 'referral', 'reason', 'archivedBy', 'open', 'tag', 'archive_note', 'viewDetails', 'actions'],
    'No Task Assigned': ['created_at', 'lead_name', 'first_name', 'last_name', 'email', 'phone', 'treatment', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'viewDetails', 'actions'],
    'Aligner Approve Leads': ['transition_date', 'lead_name', 'first_name', 'last_name', 'created_at', 'email', 'consultation_date', 'consultation_booked_with', 'lead_treatments__appointments__datetime', 'booked_with', 'phone', 'price', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'payment_method', 'deposit_date', 'viewDetails', 'actions'],
    'invisalignAdditional': ['transition_date', 'lead_name', 'first_name', 'last_name', 'created_at', 'email', 'consultation_date', 'consultation_booked_with', 'lead_treatments__appointments__datetime', 'booked_with', 'phone', 'price', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'payment_method', 'deposit_date', 'viewDetails', 'actions'],
    'Completed': ['transition_date', 'lead_name', 'first_name', 'last_name', 'created_at', 'email', 'consultation_date', 'consultation_booked_with', 'lead_treatments__appointments__datetime', 'booked_with', 'phone', 'price', 'referral', 'contact', 'lastContact', 'assignee', 'tag', 'payment_method', 'deposit_date', 'viewDetails', 'actions'],
    'Vivera table': ['lead_name', 'first_name', 'last_name', 'booked_with', 'contact', 'viewDetails', 'actions'],
};

export const DEFAULT_COLUMNS = COLUMNS_PER_TABLE['Newest Leads']; // fallback

export const COLUMN_LABELS = {
    created_at: 'Enquiry Date',
    archived_at: 'Archived Date',
    lead_name: 'Full Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    treatment: 'Treatment',
    price: 'Price',
    treatment_price: 'Price',
    estimatedValue: 'Estimated Value',
    referral: 'Referral',
    assignee: 'Assignee',
    tag: 'Tags',
    status: 'Status',
    last_contact: 'Last Contact',
    lastContact: 'Last Contacted',
    lead_treatments__lead_contacted_counts__count: 'Times contacted',
    consultation_date: 'Consult Date',
    date_of_appointment: 'Appointment Date',
    lead_treatments__appointments__datetime: 'Appointment Date',
    date_attended: 'Attended Date',
    booked_with: 'Booked With',
    consultation_booked_with: 'Consult Booked With',
    deposit_pending: 'Deposit',
    deposit_date: 'Deposit Date',
    payment_method: 'Payment Method',
    clin_check_status: 'ClinCheck',
    transition_date: 'Transition Date',
    app_method: 'Booking Method',
    app_type: 'Booking Type',
    contact: 'Contact',
    reason: 'Archive Reason',
    archivedBy: 'Archived By',
    open: 'Open to Communication',
    archive_note: 'Archive Note',
    viewDetails: 'View Details',
    actions: 'Actions',
};

export const FILTERS_PER_TABLE = {
    'Dashboard': ['treatments', 'tags', 'assignees', 'referral'],
    'Newest Leads': ['treatments', 'tags', 'assignees', 'referral', 'no-treatment'],
    'Consultation Booked Leads': ['treatments', 'tags', 'assignees', 'booked-with', 'referral', 'deposit'],
    'Consultation Attended Leads': ['treatments', 'tags', 'assignees', 'booked-with', 'referral', 'deposit', 'contacted'],

    'Treatment Started Leads': ['treatments', 'tags', 'assignees', 'booked-with', 'referral', 'consult-booked-with'],
    'Failed to attend Leads': ['treatments', 'tags', 'assignees', 'booked-with', 'referral'],
    'Completed Leads': ['treatments', 'tags', 'assignees', 'referral'],
    'Archived Leads': ['treatments', 'assignees', 'archive-reason'],
    'No Task Assigned': ['treatments', 'tags', 'assignees', 'referral', 'contacted'],
    'Aligner Approve Leads': ['treatments', 'referral', 'assignees', 'booked-with', 'tags'],
    'invisalignAdditional': ['referral', 'assignees', 'booked-with', 'tags'],
    'Completed': ['referral', 'assignees', 'booked-with', 'tags'],
    'Vivera table': ['referral', 'assignees', 'booked-with', 'tags'],
};

export const FILTER_LABELS = {
    treatments: 'Treatments',
    tags: 'Tags',
    assignees: 'Assignees',
    'booked-with': 'Booked With',
    referral: 'Referral',
    'consult-booked-with': 'Consult Booked With',
    contacted: 'Contacted',
    deposit: 'Deposit',
    'archive-reason': 'Archive Reason',
    'no-treatment': 'No Treatment',
};

export const TABS_PER_TABLE = {
    // When custom tabs are configured on a parent, the custom-tabs append effect in
    // NewLead.jsx prepends a synthetic "All" tab so users have a reset button even
    // when admin has hidden every native category. Hide the 'all' slug per-parent
    // to remove the reset entirely. The slug is 'all' (admin-hide key); the runtime
    // tab.value is 'All' (capital) to match the existing contactedCount sentinel in
    // coreThunks.js — see NewLead.jsx for that mapping.
    'Consultation Attended Leads': [
        // 'all' slug removed: post-#104, Attended is a single flat tab and the
        // synthetic All entry is functionally identical to the Attended entry —
        // showing both confused admins. NewLead's other parents (Newest Leads,
        // Dashboard) still expose 'all' because they have real sub-categories
        // (Follow up 1/2/3 + NHS + Waiting/Scheduled) that need a reset tab.
        { slug: 'attended', label: 'Attended' },
    ],
    'Dashboard': [
        // GeneralApp (Dashboard) uses NEW_TAB_HEAD (values 0/1/2/3) but does not yet
        // call resolveTabLabel or check _table_tabs — rename and hide are not wired.
        // These slugs are kept so the admin page can show the tabs for future wiring.
        { slug: 'all', label: 'All' },
        { slug: 'category-new', label: 'New' },
        { slug: 'category-nhs', label: 'NHS' },
        { slug: 'category-awaiting', label: 'Waiting/Scheduled' },
        { slug: 'follow-up-1', label: 'Follow up 1' },
        { slug: 'follow-up-2', label: 'Follow up 2' },
        { slug: 'follow-up-3', label: 'Follow up 3+' },
    ],
    'Newest Leads': [
        { slug: 'all', label: 'All' },
        // Category strip values mapped from src/constants/newLead.js DASH_NEW_HEADER:
        //   '0' → category-new · 'NHS' → category-nhs · 'AWAITING_RESPONSE' → category-awaiting
        //   '1' → follow-up-1 · '2' → follow-up-2 · '3' → follow-up-3
        { slug: 'category-new', label: 'New' },
        { slug: 'category-nhs', label: 'NHS' },
        { slug: 'category-awaiting', label: 'Waiting/Scheduled' },
        { slug: 'follow-up-1', label: 'Follow up 1' },
        { slug: 'follow-up-2', label: 'Follow up 2' },
        { slug: 'follow-up-3', label: 'Follow up 3+' },
    ],
    // Consultation Booked has no built-in sub-tab strip (CONSULTANT_BOOKED_HEAD = []).
    // The 3 booking-method tabs (In Practice / Video Call / Phone) were removed in the
    // Sprint 2 redesign (2026-04). No slugs to configure — parent-level only.

    'No Task Assigned': [
        // Status strip from TAB_HEAD_NO_TASK in src/constants/newLead.js.
        // 'all' removed: the component has no All tab and no slug map entry for it.
        { slug: 'status-new', label: 'New' },
        { slug: 'status-follow-up', label: 'Follow up' },
        { slug: 'status-consultation-booked', label: 'Consultation booked' },
        { slug: 'status-consultation-attended', label: 'Consultation attended' },
        { slug: 'status-fta', label: 'FTA' },
    ],
    'Treatment Started Leads': [
        // The 'treatment-started' slug controls visibility of the built-in board so
        // a practice that has migrated entirely to treatment-scoped custom tabs
        // can hide the original view. The 'all' slug is NOT a built-in tab on the
        // user-facing frontend — it only exists when top-level custom tabs are present.
        { slug: 'treatment-started', label: 'Treatment Started' },
    ],
    'Aligner Approve Leads': [
        { slug: 'invisalign-additional', label: 'Invisalign Additional' },
        { slug: 'vivera-table', label: 'Vivera Table' },
        { slug: 'aligner-completed', label: 'Completed' },
    ],
};

// Resolve a tab's display label, honoring per-practice rename overrides.
// Overrides live at `practice.preferences.tab_label_overrides[parentTable][slug]`
// — empty/missing values fall back to the default label. Used by both the admin
// UI (so renames show in the toggle list immediately) and the dashboard
// renderers (so the actual tab strip reflects the rename).
//
// `practicePrefs` is the practice.preferences object (or a partial). The
// resolver tolerates undefined input — returns the default in that case.
//
// Optional `globalPref` is the GlobalTableColumnPreference record for the
// parent table (Phase 2 BE contract — see src/utils/globalTablePrefsCascade.js).
// When set and the practice has no per-slug override, fall through to the
// global rename. Practice values always win; this is backward compatible
// (callers that don't pass globalPref behave exactly as before).
export const resolveTabLabel = (practicePrefs, parentTable, slug, defaultLabel, globalPref = null) => {
    const overrides = practicePrefs?.tab_label_overrides;
    const slugMap = overrides && overrides[parentTable];
    const practiceCustom = slugMap && slugMap[slug];
    if (typeof practiceCustom === 'string' && practiceCustom.trim()) return practiceCustom;

    const globalMap = globalPref?.tab_label_overrides;
    const globalCustom = globalMap && globalMap[slug];
    if (typeof globalCustom === 'string' && globalCustom.trim()) return globalCustom;

    return defaultLabel;
};

// Strip-group descriptor for the unified Tabs admin section. Each parent table
// is laid out as a sequence of strip groups that mirror what the user sees on
// the dashboard — the top-level strip first, then any sub-strips beneath their
// parent tab. Custom tabs are dropped into the strip whose placement they
// match, so admins see them in the same row as the built-ins they sit next to.
//
// Fields per strip:
//   id                unique within the parent
//   label             headline shown in the UI ("Top-level strip", "Inside …")
//   hint              sub-caption explaining where this renders on the dashboard
//   placement         which custom-tab placement value lives in this strip (null
//                     when no custom tabs are valid here, e.g. the Checklist In
//                     Progress / Follow-Up Complete sub-strip — built-ins only)
//   parentSlug        if set, this strip is conditional on that parent slug being
//                     visible; we dim the group with a [parent is hidden] cue when
//                     the parent toggle is off
//   prefsParentTable  when this strip's slugs live under a DIFFERENT parent in
//                     `practice.preferences.hidden_filters._table_tabs` than the
//                     parent we're displaying admin UI for. The dashboard filter
//                     and rename consumers read from this key, so toggles and
//                     renames have to write here too — otherwise they're silent
//                     no-ops. Defaults to the current admin parent when unset.
//   slugs             built-in slugs that live in this strip, ordered as rendered
//
// Parents not listed here fall back to a single flat strip (existing TABS_PER_TABLE).
export const TAB_STRIPS_PER_TABLE = {
    'Consultation Attended Leads': [
        {
            id: 'top',
            label: 'Top-level strip',
            hint: 'The primary tabs at the top of the page.',
            placement: 'top',
            // Attended is a single flat tab post-#104; the synthetic 'all' entry
            // was redundant (functionally identical to 'attended') and has been
            // removed from this strip. Top-level custom tabs still render here
            // alongside the built-in Attended tab.
            slugs: ['attended'],
        },
    ],
    'Treatment Started Leads': [
        {
            id: 'top',
            label: 'Top-level strip',
            hint: 'The primary tabs at the top of the page. Top-level custom tabs (Invisalign, Cosmetic & Implants, etc.) render here alongside the built-in Treatment Started board.',
            placement: 'top',
            slugs: ['treatment-started'],
        },
    ],
};

// Parent → children map for the two-level tab hierarchy in Table Defaults.
// Children remain in TABLE_NAMES for COLUMNS/FILTERS lookups but are hidden from the main tab bar.
export const TABLE_SUBTABS = {
    'Consultation Attended Leads': [],
    'Aligner Approve Leads': ['invisalignAdditional', 'Completed', 'Vivera table'],
};

// PRACTICE_EMAIL is a virtual role (the practice owner user across
// practices). Real PracticeUser roles only show in user-creation forms;
// PRACTICE_EMAIL appears in notification surfaces (Role Defaults, Bulk
// Actions, Per-User Preferences) where role pills are rendered using
// this label map.
export const ROLE_LABELS = {
    ADMIN: 'Admin',
    USER: 'User',
    Practitioner: 'Practitioner',
    TCO: 'TCO',
    SUPPORT: 'Support',
    PRACTICE_EMAIL: 'Practice Email',
};

// Date Display — field definitions and defaults
// TODO: Confirm backend field names with backend-impl (Task #1) before wiring save.
// Assumed schema: practice.preferences.date_format_config = { [key]: 'date'|'time'|'both' }
export const DATE_FORMAT_FIELDS = [
    { key: 'created_at', label: 'Enquiry / Created' },
    { key: 'last_contact', label: 'Last Contact' },
    { key: 'date_attended', label: 'Attended Date' },
    { key: 'appointment_datetime', label: 'Appointment Date' },
    { key: 'consultation_date', label: 'Consultation Date' },
    { key: 'archived_at', label: 'Archived Date' },
];

export const DEFAULT_DATE_FORMAT_CONFIG = {
    created_at: 'both',
    last_contact: 'both',
    date_attended: 'both',
    appointment_datetime: 'both',
    consultation_date: 'both',
    archived_at: 'both',
};

export const formatLastLogin = (dateStr) => {
    if (!dateStr) return { text: 'Never logged in', color: '#DC2626' };
    const diff = Date.now() - new Date(dateStr).getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (days === 0) return { text: 'Active today', color: '#16A34A' };
    if (days === 1) return { text: 'Active yesterday', color: '#16A34A' };
    if (days < 7) return { text: `Active ${days}d ago`, color: '#F59E0B' };
    if (days < 30) return { text: `Active ${Math.floor(days / 7)}w ago`, color: '#F59E0B' };
    if (days < 365) return { text: `Active ${Math.floor(days / 30)}mo ago`, color: '#DC2626' };
    return { text: `Active ${Math.floor(days / 365)}y ago`, color: '#DC2626' };
};

